var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SQSClient, ReceiveMessageCommand, GetQueueUrlCommand, SendMessageCommand, DeleteMessageCommand } from "@aws-sdk/client-sqs";
import { Subject } from 'rxjs';
import { apiDefinition } from '../api';
import { MessageWrapper } from '.';
export class SqsAsyncApi {
    constructor() {
        this.name = typeof this;
        this.connected = Promise.resolve(true);
        this.inbox = new Subject();
        this._subscriptions = {};
        this._client = new SQSClient({});
    }
    disconnect() {
        this._client.destroy();
        this.connected = Promise.resolve(false);
    }
    _getSqsConfig(channel) {
        return __awaiter(this, void 0, void 0, function* () {
            const sqsConfig = apiDefinition.channels[channel].bindings.sqs;
            // ! Evaluate response if not exists queue
            if (sqsConfig) {
                const response = yield this._client.send(new GetQueueUrlCommand({
                    QueueName: sqsConfig.queue
                }));
                if (response.$metadata.httpStatusCode !== 200)
                    console.error(Error(`Failed to send ack to queue ${sqsConfig.queue}`));
            }
            return sqsConfig;
        });
    }
    send(ceMsg) {
        return __awaiter(this, void 0, void 0, function* () {
            const { originChannel } = ceMsg.data.metadata;
            const sqsConfig = yield this._getSqsConfig(originChannel);
            if (sqsConfig) {
                const commandOptions = {
                    QueueUrl: sqsConfig.queue,
                    MessageBody: JSON.stringify(ceMsg),
                };
                const response = yield this._client.send(new SendMessageCommand(commandOptions));
                if (response.$metadata.httpStatusCode !== 200)
                    console.error(Error(`Failed to send ack to queue ${sqsConfig.queue}`));
            }
        });
    }
    sendAck(replyId, channel) {
        return __awaiter(this, void 0, void 0, function* () {
            const sqsConfig = yield this._getSqsConfig(channel);
            if (sqsConfig) {
                const response = yield this._client.send(new DeleteMessageCommand({
                    QueueUrl: sqsConfig.queue,
                    ReceiptHandle: replyId
                }));
                if (response.$metadata.httpStatusCode !== 200)
                    console.error(Error(`Failed to send ack to queue ${sqsConfig.queue}`));
            }
        });
    }
    subscribe(originChannel, channel) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const sqsConfig = yield this._getSqsConfig(originChannel);
            if (this._subscriptions[originChannel] === undefined) {
                this._subscriptions[originChannel] = 1;
                if (sqsConfig) {
                    while (this._subscriptions[originChannel]) {
                        const response = yield this._client.send(new ReceiveMessageCommand({
                            QueueUrl: sqsConfig.queue,
                            WaitTimeSeconds: 2
                        }));
                        if (response.$metadata.httpStatusCode !== 200)
                            console.error(Error(`Failed to send ack to queue ${sqsConfig.queue} in channel ${channel}`));
                        (_a = response.Messages) === null || _a === void 0 ? void 0 : _a.map((sqsMsg) => {
                            const msg = this.toMessageWrapper(sqsMsg);
                            if (msg)
                                this.inbox.next(msg);
                        });
                    }
                }
            }
            else
                this._subscriptions[originChannel]++;
        });
    }
    unsubscribe(originChannel, channel) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._subscriptions[originChannel] === 1)
                delete this._subscriptions[originChannel];
            else
                this._subscriptions[originChannel]--;
        });
    }
    toMessageWrapper(sqsMsg) {
        // ! Chapuza de AWS -> envia por la cola de SQS con el campo body en Mayusculas
        // ! mientras que cuando es de un event source de SQS viene en minusculas
        const body = sqsMsg.Body || sqsMsg["body"];
        if (!body) {
            console.error("Message not contain body");
            return;
        }
        const ceMsg = JSON.parse(body);
        return new MessageWrapper(this, ceMsg, sqsMsg.ReceiptHandle);
    }
}
